import produce from 'immer';

import {
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_ERROR,
  GET_COMPANIES,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_ERROR,
  GET_COMPANY,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_ERROR,
  GET_POSITIONS,
  GET_POSITIONS_SUCCESS,
  GET_POSITIONS_ERROR,
  GET_CITY,
  GET_CITY_SUCCESS,
  GET_CITY_ERROR,
  CLEAR_CITY,
  GET_POSITION,
  GET_POSITION_SUCCESS,
  GET_POSITION_ERROR,
  CLEAR_POSITION,
  CLEAR_COMPANY,
  CLEAR_ALL,
} from './constants';

export interface Loading {
  cities: boolean;
  companies: boolean;
  positions: boolean;
}

export interface filtersState {
  optionsCities : Array<object>;
  optionsCity: Array<object>;
  optionsCompanies : Array<object>;
  optionsCompany: Array<object>;
  optionsPositions : Array<object>;
  optionsPosition : Array<object>;
  error: boolean;
  loading: Loading;
}

export const initialState: filtersState = {
  optionsCities : [],
  optionsCity: [],
  optionsCompanies : [],
  optionsCompany: [],
  optionsPositions : [],
  optionsPosition : [],
  error: false,
  loading: {
    cities: false,
    companies: false,
    positions: false
  },
};


const filtersReducer = (state = initialState, action: any) =>

  produce(state, draft => {
    switch (action.type) {
      case GET_CITIES:
        draft.loading.cities = true;
        break;
      case GET_CITIES_SUCCESS:
        draft.loading.cities = false;
        draft.optionsCities = action.response.data;
        break;
      case GET_CITIES_ERROR:
        draft.loading.cities = false;
        draft.error = action.error;
        break;

      case GET_CITY:
        draft.loading.cities = true;
        break;
      case GET_CITY_SUCCESS:
        draft.loading.cities = false;
        draft.optionsCity = [{
          value: action.response.data.value,
          label: action.response.data.label,
        }];
        break;
      case GET_CITY_ERROR:
        draft.loading.cities = false;
        draft.error = action.error;
        break;   
      case GET_POSITION:
        draft.loading.positions = true;
        break;
      case GET_POSITION_SUCCESS:
        draft.loading.positions = false;
        // draft.optionsPosition = action.response.data;
        draft.optionsPosition = [{
          value: action.response.data.value,
          label: action.response.data.label,
        }];
        break;
      case GET_POSITION_ERROR:
        draft.loading.positions = false;
        draft.error = action.error;
        break;     
      case GET_COMPANIES:
        draft.loading.companies = true;
        break;
      case GET_COMPANIES_SUCCESS:
        draft.loading.companies = false;
        draft.optionsCompanies = action.response.data;
        break;
      case GET_COMPANIES_ERROR:
        draft.loading.companies = false;
        draft.error = action.error;
        break;
      case GET_COMPANY:
        draft.loading.companies = true;
        break;
      case GET_COMPANY_SUCCESS:
        draft.loading.companies = false;
        draft.optionsCompany = [{
          value: action.response.data.value,
          label: action.response.data.label,
        }];
        break;
      case GET_COMPANY_ERROR:
        draft.loading.companies = false;
        draft.error = action.error;
        break;  
      case GET_POSITIONS:
        draft.loading.positions = true;
        break;
      case GET_POSITIONS_SUCCESS:
        draft.loading.positions = false;
        draft.optionsPositions = action.response.data;
        break;
      case GET_POSITIONS_ERROR:
        draft.loading.positions = false;
        draft.error = action.error;
        break;
      case CLEAR_POSITION:
        draft.optionsPosition = [];
        break;  
      case CLEAR_CITY:
        draft.optionsCities = [];
        draft.optionsCity = [];
        break;
      case CLEAR_COMPANY:
        draft.optionsCompany = [];
        break;  
      case CLEAR_ALL:
        draft.optionsPositions = [];
        draft.optionsPosition = [];
        draft.optionsCompany = [];
        draft.optionsCity = [];
        draft.optionsCities = [];
        
        break;  

    }
  });

export default filtersReducer;
